module.exports = __webpack_public_path__ + "img/entia-portafolio-energia-carrusel-3.cd0355ce.webp";